import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import {
    translateFormFieldLabel,
    translateFormFieldValue,
} from '../../../../../../../helpers/collaborativeIndexations'
import { DateCalendarContainer } from '../../Commons/DateCalendar.js'
import Select from '../../../../Forms/Commons/Select'

class Event extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        updateFieldValue: PropTypes.func.isRequired,
        fields: PropTypes.object.isRequired,
    }

    constructor(props)
    {
        super(props)

        this.updateFieldValueFromEvent = this.updateFieldValueFromEvent.bind(this)
        this.updateFieldValueFromSelectedOption = this.updateFieldValueFromSelectedOption.bind(this)
    }

    updateFieldValueFromEvent(field)
    {
        return event => this.props.updateFieldValue(field, event.target.value)
    }

    updateFieldValueFromSelectedOption(field, option)
    {
        this.props.updateFieldValue(field, option.value)
    }

    render()
    {
        const { t, fields } = this.props

        return (
            <div>
                { t('visualizer:toolbar.left.collaborativeIndexationCreation.form.french_civil_registry.steps.event.title') }
                <div>
                    <div className={'form-group'}>
                        <label>{ translateFormFieldLabel(t, 'eventType') }</label>
                        <Select
                            options={[
                                { value: '', label: translateFormFieldValue(t, 'eventType', 'default')},
                                { value: 'birth', label: translateFormFieldValue(t, 'eventType', 'birth')},
                                { value: 'baptism', label: translateFormFieldValue(t, 'eventType', 'baptism')},
                                { value: 'wedding', label: translateFormFieldValue(t, 'eventType', 'wedding')},
                                { value: 'death', label: translateFormFieldValue(t, 'eventType', 'death')},
                                { value: 'burial', label: translateFormFieldValue(t, 'eventType', 'burial')},
                            ]}
                            value={fields.eventType === null ? '' : fields.eventType}
                            onChange={ option => this.updateFieldValueFromSelectedOption('eventType', option) }
                            hasFocus={true}
                            isSearchable={true}
                        />
                    </div>
                    <DateCalendarContainer fieldName={"eventDate"} />
                    <div className={'form-group'}>
                        <label>{ translateFormFieldLabel(t, 'eventPlace') }</label>
                        <input
                            type={ 'text' }
                            defaultValue={fields.eventPlace}
                            onChange={ this.updateFieldValueFromEvent('eventPlace') }
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(Event)
